import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/shared/snackbar.service';
import { LohiDashboardService, MonthlyCost, UpdateMonthlyCostRequest } from '../lohi-dashboard.service';

@Component({
  selector: 'lohi-app-update-monthly-costs-modal',
  templateUrl: './update-costs-modal.component.html',
  styleUrls: ['./update-costs.component.scss'],
})
export class UpdateMonthlyCostsModalComponent implements OnInit {
  public drivers: any[] = [];
  public isLoading = false;

  constructor(
    private dialogRef: MatDialogRef<UpdateMonthlyCostsModalComponent>,
    private lohiDashboardService: LohiDashboardService,
    private snackBar: SnackBarService,
  ) {}

  public ngOnInit(): void {
    this.fetchMonthlyCosts();
  }

  public fetchMonthlyCosts(): void {
    this.isLoading = true;
    this.lohiDashboardService.getMonthlyCosts$().subscribe(
      (costs: MonthlyCost[]) => {
        this.drivers = costs.map((cost) => ({
          id: cost.id,
          driverId: cost.driverId,
          name: cost.driverName,
          payType: cost.payType === 'percentage' ? '% Of Load' : 'Month',
          percentGross: cost.payAmountPercentage ? cost.payAmountPercentage : 0,
          payPerMonth: cost.payAmountFixedCents ? cost.payAmountFixedCents / 100 : null,
          insurance: cost.insuranceCostCents / 100,
          maintenanceCost: cost.maintenanceCostCents / 100,
        }));
        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching monthly costs:', error);
        this.isLoading = false;
      },
    );
  }

  public onUpdate(): void {
    const updateCosts: UpdateMonthlyCostRequest[] = this.drivers.map((driver) => ({
      driverId: driver.driverId,
      payType: driver.payType === '% Of Load' ? 'percentage' : 'fixed',
      payAmountFixedCents: driver.payType === '% Of Load' ? null : driver.payPerMonth * 100,
      payAmountPercentage: driver.payType === 'Month' ? null : driver.percentGross,
      insuranceCostCents: driver.insurance * 100,
      maintenanceCostCents: driver.maintenanceCost * 100,
    }));

    this.isLoading = true;
    this.lohiDashboardService.updateMonthlyCosts$(updateCosts).subscribe(
      (response) => {
        this.isLoading = false;
        this.snackBar.showMessage('Updated cost');
      },
      (error) => {
        console.error('Error updating monthly costs:', error);
        this.isLoading = false;
      },
    );
  }

  public onCancel(): void {
    this.dialogRef.close();
  }

  public copyInsuranceToAll(driverIndex: number): void {
    const insuranceAmount = this.drivers[driverIndex].insurance;
    this.drivers.forEach((driver) => (driver.insurance = insuranceAmount));
  }

  public trackByDriverId(index: number, driver: any): string {
    return driver.driverId;
  }
}
